// 导入基本公共资源
import http from './../../../base/api/public'

let sysConfig = require('@/../config/sysConfig')
let service = require('@/../config/serviceList')
// 定义访问网关的api,分为开发，测试，以及生产环境
let apiPre = sysConfig.apiPre
export default {
  // 车管理
  getCars(params) {
    console.log('params:' + JSON.stringify(params))
    return http.requestPost(apiPre + service.res + '/res/car/getCars', params)
  },
  getCarByLicense(params) {
    console.log('params:' + JSON.stringify(params))
    return http.requestPost(apiPre + service.res + '/res/car/getCarByLicense', params)
  },
  saveOrUpdateCar(params) {
    console.log('params:' + JSON.stringify(params))
    return http.requestPut(apiPre + service.res + '/res/car/saveOrUpdateCar', params)
  },
  deleteCar(params) {
    console.log('params:' + JSON.stringify(params))
    return http.requestPost(apiPre + service.res + '/res/car/deleteCar', params)
  },
  checkDuplicateCar(license) {
    console.log('params: 车牌号' + license)
    return http.requestPost(apiPre + service.res + '/res/car/getCarByLicense', license)
  },
  // 车型管理
  getModels(params) {
    console.log('params:' + JSON.stringify(params))
    return http.requestPost(apiPre + service.res + '/res/model/getModels', params)
  },
  getModelByName(params) {
    console.log('params:' + JSON.stringify(params))
    return http.requestPost(apiPre + service.res + '/res/model/getModelByName', params)
  },
  saveOrUpdateModel(params) {
    console.log('params:' + JSON.stringify(params))
    return http.requestPut(apiPre + service.res + '/res/model/saveOrUpdateModel', params)
  },
  deleteModel(params) {
    console.log('params:' + JSON.stringify(params))
    return http.requestPost(apiPre + service.res + '/res/model/deleteModel', params)
  },

  checkDuplicateModel(model) {
    console.log('params: 车型' + model)
    return http.requestPost(apiPre + service.res + '/res/model/getModelByName', model)
  },
  // 品牌管理
  getBrands(params) {
    console.log('params:' + JSON.stringify(params))
    return http.requestPost(apiPre + service.res + '/res/brand/getBrands', params)
  },
  getBrandsByName(params) {
    console.log('params:' + JSON.stringify(params))
    return http.requestPost(apiPre + service.res + '/res/brand/getBrandsByName', params)
  },
  saveOrUpdateBrand(params) {
    console.log('params:' + JSON.stringify(params))
    return http.requestPut(apiPre + service.res + '/res/brand/saveOrUpdateBrand', params)
  },
  deleteBrand(params) {
    console.log('params:' + JSON.stringify(params))
    return http.requestPost(apiPre + service.res + '/res/brand/deleteBrand', params)
  },
  checkDuplicateBrand(brand) {
    console.log('params: 品牌' + brand)
    return http.requestPost(apiPre + service.res + '/res/brand/getBrandsByName', brand)
  }
}



// WEBPACK FOOTER //
// ./src/module/resourceCenter/api/carApi.js